module.exports = __webpack_public_path__ + "img/DSC_0080.ac4aeca5.jpg";